import { REPLACE } from './actions';

const initialState = {
    concepts: []
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE:
            return {
                ...state,
                concepts: action.concepts
            }
        default:
            return state;
    }
}